import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import { InsuranceIcon } from 'refactored/ui/icons';
import SoFormCollapsableInput from './SoFormCollapsableInput';
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const TextInput = styled.input`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 12px 16px;
  gap: 12px;

  width: 100%;
  height: 48px;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 900 */
  color: #263340;

  &::placeholder {
    /* grey / 500 */
    color: #94a6b8;
  }
  outline: none;
`;

const RowContainer = styled.div`
  display: flex;
  /* border: 5px solid red; */
  gap: 8px;
  align-items: center;
  img {
    height: 46px;
  }
`;

const SoFormInsurance = ({ className }) => {
  const { t } = useTranslation('Catalog');

  // state
  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const { add_insurance, insured_for } = stepsState.complements;

  const displayValue = insured_for > 0 ? insured_for : '';

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {t('complements.aditional_insurance')}
          </SoFormPanelText>
          {/* <GirdedQuestionIcon /> */}
        </SoFormRowContainer>
        <TempContainer>
          <SoFormCollapsableInput
            isSelected={add_insurance}
            setIsSelected={stepsApi.setAddInsurance}
            icon={<InsuranceIcon />}
            label={t('complements.insure_with_reale')}
          >
            <RowContainer>
              <TextInput
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  stepsApi.setInsuredFor(value);
                }}
                value={displayValue}
                placeholder={t('complements.load_value')}
              />
              <img src="/reale.png" alt="Reale Seguros" />
            </RowContainer>
          </SoFormCollapsableInput>
        </TempContainer>
      </SoFormPanel>
    </div>
  );
};

SoFormInsurance.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default styled(SoFormInsurance)`
  ${regularCSS}
`;
